<script setup lang="ts">
  import AiChat from '@/components/app/chat/components/AiChat.vue'
  import { AIChatSessionTypeEnum, type CustomerCase } from '@/types/generated'
  import { inject, type Ref } from 'vue'

  // Inject case data from parent component
  const caseData = inject<Ref<CustomerCase>>('caseData')

  // Pass case-specific props to the shared AiChat component
  const chatProps = {
    caseUuid: caseData?.value?.uuid,
    sessionType: AIChatSessionTypeEnum.CASE
    // Add any other case-specific props here
  }
</script>

<template>
  <AiChat v-bind="chatProps" />
</template>
